module.exports = "/fonts/themify.svg?9c8e96ecc7fa01e6ebcd196495ed2db5";